import SquadExtraBoldText from './SquadExtraBoldText';

export default SquadExtraBoldText;
